var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"w-full p-2 bg-primary-500 text-white rounded flex items-center justify-center",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.field.label)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }